import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/shared/api/client"
import type { Duration } from "@/shared/lib/types"

async function fetchDurations(): Promise<Duration[]> {
	const { data } = await apiClient.get<Duration[]>("/durations")
	return data
}

export function useDurations() {
	return useQuery({
		queryKey: ["durations"],
		queryFn: fetchDurations,
	})
}
